import { Space } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import {
  rangePickerTriggerDateFormat,
  RangePickerTriggerProps,
} from 'components/organisms/projects-report/common/range-picker';
import { Range } from 'components/organisms/projects-report/common/range-picker/types';
import { useTranslation } from 'hooks/use-translation';

export const RangePickerTrigger: FC<RangePickerTriggerProps> = ({ range }) => {
  return (
    <Button type="text" size="small">
      <Space size={4}>
        {useTranslation('reports.intervals.time_period')}:
        <strong>
          {range.type === Range.Custom || range.type === Range.Advanced ? (
            `${range.startDate.format(
              rangePickerTriggerDateFormat,
            )} - ${range.endDate.format(rangePickerTriggerDateFormat)}`
          ) : (
            <FormattedMessage id={range.type} />
          )}
        </strong>
      </Space>
    </Button>
  );
};
